// api.js
import axios from "axios";
import { useSelector } from "react-redux";
import { API_URL } from "../network/api";

// Create axios instance
export const api = axios.create({
  baseURL: API_URL,
  headers: {    
    "Content-Type": "application/json",
  },
});

// Interceptor to attach relatedShopID
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || null;

    if (!token) return config

    config.headers["Authorization"] = `Bearer ${token}`;
    // Example: get from localStorage (you can also get from Zustand, Redux, or context)
    const relatedShop = localStorage.getItem("shopID");

    if (relatedShop) {
      config.params = {
        ...config.params,
        relatedShop,
      };
      if (
        config.method === "post" ||
        config.method === "put" ||
        config.method === "patch"
      ) {
        if (config.data instanceof FormData) {
          config.data.append("relatedShop", relatedShop);
        } else {
          config.data = {
            ...config.data,
            relatedShop: relatedShop,
          };
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);
